import { useTranslate } from "@similarweb/i18n-provider";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { percentageFilter } from "app/filters/ngFilters";
import { ZERO } from "app/pages/activation/components/HomeWithData/ShareData/constants";
import { addPercentPoint } from "app/pages/activation/helpers/format";
import type { ShareOfVoiceWidgetResponse } from "app/pages/activation/types/api";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";

import { TIME_PERIOD } from "../../MyTrafficShare/BodyByState/constants";

import * as SC from "./styles";
import { WIDGET_MESSAGE, WIDGET_MESSAGE_SINGLE } from "./texts";

interface IDefaultSchema {
    trafficData?: ShareOfVoiceWidgetResponse;
}

const Default = ({ trafficData }: IDefaultSchema) => {
    const { translate } = useTranslate();
    const amountOfTopics = trafficData?.amountOfTopics ?? 0;
    const isSingle = amountOfTopics === 1;
    const message = isSingle ? WIDGET_MESSAGE_SINGLE : WIDGET_MESSAGE;

    return (
        <SC.Container>
            <SC.InfoSectionLeft>
                <SC.ShareOfVoice>
                    {FORMATTERS.percentSign(trafficData?.weightedAverageShareOfVoice, DEFAULT_DECIMAL)}
                </SC.ShareOfVoice>
                <SC.ChangeWrapper>
                    <ChangeIndication
                        className="customChangeIndication"
                        changeValue={`${addPercentPoint(percentageFilter()(trafficData?.weightedAverageShareOfVoiceChange, 2))} ${TIME_PERIOD}`}
                        isIncreasing={(trafficData?.weightedAverageShareOfVoiceChange ?? 0) > ZERO}
                        isNotChanged={(trafficData?.weightedAverageShareOfVoiceChange ?? 0) === ZERO}
                    />
                </SC.ChangeWrapper>
                <SC.Message>{translate(message, { num: amountOfTopics })}</SC.Message>
            </SC.InfoSectionLeft>
        </SC.Container>
    );
};

export default Default;
